import _ from 'lodash'
import Model from 'model/model'
import View from 'view/view'

const SyncView = View.extend({
    initialize() {
        _.bindAll(this, _.functionsIn(this))

        this.initModel()
        this.subscribe()
    },

    initModel() {
        this.model = Model.extend({
            url() {
                return this.get('url')
            },
        })

        // eslint-disable-next-line new-cap
        this.model = new this.model({ url: this.$el.data('url') })
    },

    subscribe() {
        this.on('update', this.update)
        this.model.on('request', this.showLoader).on('error', this.showError).on('sync', this.render)
    },

    update() {
        return this.model.fetch()
    },

    showLoader() {
        this.hideError()
        this.$el.addClass('is-loading')
    },

    hideLoader() {
        this.$el.removeClass('is-loading')
    },

    showError() {
        this.hideLoader()
        this.$el.addClass('is-error')
    },

    hideError() {
        this.$el.removeClass('is-error')
    },

    render(model, resp) {
        this.hideLoader()
        this.$el.html(resp.markup)
        this.trigger('SyncView:render')
        return this
    },
})

export default SyncView
